export default __webpack_public_path__ + "static/media/lunch.5957d8ac.svg";